"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Sr = (props) => (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 900 600", ...props },
    react_1.default.createElement("path", { fill: "#007A33", d: "M0 0h900v600H0z" }),
    react_1.default.createElement("path", { fill: "#fff", d: "M0 120h900v360H0z" }),
    react_1.default.createElement("path", { fill: "#C8102E", d: "M0 180h900v240H0z" }),
    react_1.default.createElement("path", { fill: "#FFCD00", d: "m450 191.459 70.534 217.082-184.661-134.164h228.254L379.466 408.541z" })));
exports.default = Sr;
//# sourceMappingURL=Sr.js.map